(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["global-health-impact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '[data-global-health-impact]';
    const numberSelector = '[data-count-target]';

    const getCountParts = (value) => {
      const match = String(value).trim().match(/^([^0-9-]*)(-?[\d.,]+)(.*)$/);

      if (!match) {
        return null;
      }

      const numericValue = Number(match[2].replace(/[.,]/g, ''));

      if (!Number.isFinite(numericValue)) {
        return null;
      }

      return {
        prefix: match[1],
        value: numericValue,
        suffix: match[3],
      };
    };

    const animateNumber = (element, duration) => {
      if (element.dataset.countAnimated === 'true') {
        return;
      }

      const countParts = getCountParts(element.dataset.countTarget);

      if (!countParts) {
        return;
      }

      element.dataset.countAnimated = 'true';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        element.textContent = element.dataset.countTarget;
        return;
      }

      const startTime = performance.now();
      const formatter = new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 });

      const update = (currentTime) => {
        const progress = Math.min((currentTime - startTime) / duration, 1);
        const easedProgress = 1 - Math.pow(1 - progress, 3);
        const currentValue = Math.round(countParts.value * easedProgress);

        element.textContent = `${countParts.prefix}${formatter.format(currentValue)}${countParts.suffix}`;

        if (progress < 1) {
          requestAnimationFrame(update);
        } else {
          element.textContent = element.dataset.countTarget;
        }
      };

      requestAnimationFrame(update);
    };

    const initSection = (section) => {
      const numbers = section.querySelectorAll(numberSelector);
      const duration = Number(section.dataset.countDuration) || 1400;

      if (!numbers.length) {
        return;
      }

      if (!('IntersectionObserver' in window)) {
        numbers.forEach((number) => animateNumber(number, duration));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              return;
            }

            numbers.forEach((number) => animateNumber(number, duration));
            observer.disconnect();
          });
        },
        { threshold: 0.35 }
      );

      observer.observe(section);
    };

    const initAllSections = () => {
      document.querySelectorAll(sectionSelector).forEach(initSection);
    };

    initAllSections();
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector(sectionSelector);

      if (section) {
        initSection(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
